import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";

import styles from './AllAppliedCleanerApplicationsPage.module.scss';
import {cleanerApplicationsActions} from "../../store/slices/cleanerApplicationsSlice";
import CustomerBioShort from "../../components/CustomerBioShort/CustomerBioShort";
import Pagination from "../../components/Pagination/Pagination";
import Loader from "../../components/Loader/Loader";
import EmptyState from "../EmptyState/EmptyState";
import waiting from '../../constants/images/detailsOrder/waiting.svg';
import isCleaner from "../../HOC/IsCleaner";

const AllAppliedCleanerApplicationsPage = () => {
        const [currentPage, setCurrentPage] = useState(1); //pagination

        const dispatch = useDispatch();
        const {cleanerApplicationsByCurrentCleaner, status} = useSelector(state => state.cleanerApplications);

        const getAllCleanerApplicationByCurrentCleaner = async () => {
            try {
                await dispatch(cleanerApplicationsActions.getAllByCurrentCleaner({page: currentPage}));
            } catch (error) {
                console.error(error);
            }
        }

        useEffect(() => {
            getAllCleanerApplicationByCurrentCleaner();
        }, []);

        useEffect(() => {
            getAllCleanerApplicationByCurrentCleaner();
        }, [currentPage]);

        if (status === 'loading') {
            return <Loader/>
        }

        return (
            <div className={styles.allAppliedCleanerApplicationsPage_wrapper}>
                <div className={styles.allAppliedCleanerApplicationsPage}>
                    <h1 className={styles.allAppliedCleanerApplicationsPage_title}>Подані заявки</h1>

                    <div className={styles.allAppliedCleanerApplicationsPage_pagination}>
                        <div className={styles.allAppliedCleanerApplicationsPage_pagination_content}>
                            {/*<SearchBar type={'cleaner'} page={currentPage} setPage={setCurrentPage}/>*/}

                            {cleanerApplicationsByCurrentCleaner?.length === 0 &&
                                <EmptyState
                                    icon={waiting}
                                    title={'У вас поки немає поданих заявок'}
                                    description={'Оберіть замовлення та подайте свою заявку замовнику'}
                                />}

                            {cleanerApplicationsByCurrentCleaner?.map((item, index) =>
                                <CustomerBioShort
                                    key={index}
                                    order={item?.request}
                                    type={'alreadyApplied'}
                                    offerId={null}
                                    orderId={null}
                                    application={item?.application}
                                    cleanerApplicationId={item?.id}
                                />
                            )}
                        </div>

                        {cleanerApplicationsByCurrentCleaner?.length > 0 && <Pagination
                            type={'applied-cleaner-applications'}
                            currentPage={currentPage}
                            onPageChange={setCurrentPage}
                        />}
                    </div>
                </div>
            </div>
        );
    }
;

export default isCleaner(AllAppliedCleanerApplicationsPage);
